import api from "../../api";
import { useEffect, useState } from 'react'
import styles from './style.module.css'
import Icons from "../../components/icons";
import { Link } from "react-router-dom";
import Title from "../../components/title";
import { useSeasons } from "../../components/utils/use-seasons";
import SeasonCheckboxGroup from "../../components/season-checkbox-group";
import SchoolCardList from "../../components/school-card-list";
import SchoolCard from "../../components/school-card";
import { Breadcrumbs, PreLoader } from "../../components";

const Schools = () => {
    const [loading, setLoading] = useState(false);
    const titleName = 'Школа московского фтизиатра';
    const { value: seasonsValue, handleChange: handleTagsChange, setValue: setSeasonsValue } = useSeasons();
    const [schoolsList, setSchoolsList] = useState([]);
    const currentYear = new Date().getFullYear();

    const getSchools = ({ seasons }) => {
        setLoading(true)
        api.getSchoolsList({ seasons })
            .then(res => {
                setLoading(false)
                setSchoolsList(res)
            })
    }

    useEffect(_ => {
        getSchools({ seasons: seasonsValue })
    }, [seasonsValue])

    useEffect(_ => {
        api.getSeason()
            .then(seasons => {
                setSeasonsValue(seasons.map(season => { if (season.year === currentYear) { return ({ ...season, value: true }) } else { return ({ ...season, value: false }) } }))
            })
    }, []);

    return (
        <>
            {loading ? (
                <PreLoader />
            ) : (
                <>
                    <Title title={titleName} />
                    <div className={styles.schools__row}>
                        <Breadcrumbs urls={[{ title: titleName, path: '' }]} />
                        <div className={styles.schools__container}>
                            <div>
                                {schoolsList.map(item => {
                                    return (
                                        <SchoolCardList season_number={item.season_number}>
                                            <div className={styles.schools__season_number}>Сезон №{item.season_number}</div>
                                            {item.season_school.map(school =>
                                                <SchoolCard
                                                    season_number={item.season_number}
                                                    {...school}
                                                />
                                            )}
                                        </SchoolCardList>
                                    )
                                })}
                            </div>
                            <div className={styles.schools__categories}>
                                <div className={styles.schools__categories__title}>Сезоны</div>
                                <div className={styles.schools__categories__name}>
                                    <div className={styles.schools__categories__item}>
                                        <SeasonCheckboxGroup
                                            schoolsList={schoolsList}
                                            values={seasonsValue}
                                            handleChange={value => {
                                                handleTagsChange(value)
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </>
    );
}

export default Schools;